import { ErrorMessage, Field } from "formik";
import React from "react";

const FormField = ({
  htmlFor,
  label,
  type,
  id,
  placeholder,
  name,
  className,
  as,
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {label}
      </label>
      <Field
        type={type}
        id={id}
        name={name}
        className="focus:outline-none bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
        placeholder={placeholder}
        as={as}
      />
      <ErrorMessage name={name} component="div" className="text-red-500" />
    </div>
  );
};

export default FormField;
